import script from "./ConsumerOrderCompleteView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerOrderCompleteView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerOrderCompleteView.vue?vue&type=style&index=0&id=3263497a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3263497a"]])

export default __exports__